"use client";

/**
 * NewForm DS hover icon — a rocket for "media buying": launch-and-manage.
 * On hover the whole ship does the send-style launch (up, out the top,
 * back in from below) while the pad stays put.
 * See ./hoverIcon for the colour/animation conventions.
 */

import { type HoverIconProps, HoverIconSvg } from "./hoverIcon";

export function RocketIcon({ size, className }: HoverIconProps) {
  return (
    <HoverIconSvg size={size} className={className}>
      <g className="g a-launch">
        <path d="M12 2.6c2.6 1.8 4 4.6 4 7.6 0 1.9-.5 3.7-1.4 5.2H9.4A9.7 9.7 0 0 1 8 10.2c0-3 1.4-5.8 4-7.6Z" />
        <circle cx="12" cy="9.4" r="1.7" />
        <path d="M9.4 15.4 7 18.2M14.6 15.4 17 18.2" />
      </g>
      <path d="M10.2 19.4h3.6" />
    </HoverIconSvg>
  );
}
